import ToastContainer from './UiToaster';
import { createToast } from './utils';

const toast = (text: string) => createToast('default', text);
toast.success = (text: string) => createToast('success', text);
toast.error = (text: string) => createToast('error', text);

export {
  toast,
  ToastContainer,
};
